export const FETCHING = "USER/FETCHING";
export const SUCCESS = "USER/SUCCESS";
export const ERROR = "USER/ERROR";
export const GET_USERS = "USER/GET_USERS";
export const SEARCH_USER = "USER/SEARCH_USER"